export interface ModelPeriodDates151Payload {
  id?: number;
  model151CategoryId?: number;
  fromDate?: string;
  toDate?: string;
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  const text = String(value).trim();
  return text.length > 0 ? text : undefined;
}

function extractModel151CategoryId(input: any): number | undefined {
  const direct = toNumber(input?.model151CategoryId);
  if (direct !== undefined) {
    return direct;
  }
  return toNumber(input?.model151Categories?.id);
}

export function buildModelPeriodDates151Payload(input: any): ModelPeriodDates151Payload {
  const payload: ModelPeriodDates151Payload = {};

  const id = toNumber(input?.id);
  if (id !== undefined) payload.id = id;

  const model151CategoryId = extractModel151CategoryId(input);
  if (model151CategoryId !== undefined) payload.model151CategoryId = model151CategoryId;

  const fromDate = toStringValue(input?.fromDate);
  if (fromDate !== undefined) payload.fromDate = fromDate;

  const toDate = toStringValue(input?.toDate);
  if (toDate !== undefined) payload.toDate = toDate;

  return payload;
}
